window.addEventListener('load', (event) => {
    console.log('spp2 fully loaded', Shopify.locale);

    if (!document.querySelector('.spp2__widget')) return;

    const paiement_widget = document.querySelector('.spp2__widget');
    const allInstallments = paiement_widget.querySelector('.spp2__widget-params');

    paiement_widget.addEventListener('click', (event) => {
        event.target.id === "spp2-installment-payment-option" ? allInstallments.style = "display:block;visibility:visible" : allInstallments.style = "display:none;visibility:hidden";
    })

    if (Shopify.locale === 'fr') return;
    const transData = {
        "en":
        {
            "fullPaiement": "One-time payment",
            "installmentPaiement": "Payment in 2 instalments free of charge",
            "firstInstallment": "First installement:",
            "secondInstallment": "<b>2nd payment:</b> Automatically debited 30 days after the order."
        },
        "de":
        {
            "fullPaiement": "Einmalige Zahlung",
            "installmentPaiement": "Zahlung in 2 Instalationen gebührenfrei",
            "firstInstallment": "Erste Einzahlung:",
            "secondInstallment": "<b>2. Zahlung:</b> Automatische Abbuchung 30 Tage nach der Bestellung."
        },
        "es":
        {
            "fullPaiement": "Pago único",
            "installmentPaiement": "Pago en 2 plazos sin gastos",
            "firstInstallment": "Primer plazo:",
            "secondInstallment": "<b>2º pago:</b> Cargo automático 30 días después del pedido."
        },
        "nl":
        {
            "fullPaiement": "Eenmalige betaling",
            "installmentPaiement": "Betaling in 2 termijnen gratis",
            "firstInstallment": "Eerste termijn:",
            "secondInstallment": "<b>2e betaling:</b> Automatisch afgeschreven 30 dagen na de bestelling."
        },
        "it":
        {
            "fullPaiement": "Pagamento unico",
            "installmentPaiement": "Pagamento gratuito in 2 rate",
            "firstInstallment": "Prima rata:",
            "secondInstallment": "<b>2° pagamento:</b> Addebito automatico 30 giorni dopo l'ordine."
        }
    };

    let lang = transData[`${Shopify.locale}`];

    const fullPaiement = paiement_widget.querySelector('label[for="spp2-full-payment-option"]');
    const installmentPaiement = paiement_widget.querySelector('label[for="spp2-installment-payment-option"]');
    const installments = paiement_widget.querySelectorAll('.spp2__widget-param');

    fullPaiement.innerText = lang.fullPaiement;
    installmentPaiement.innerText = lang.installmentPaiement;
    installments[0].querySelector('b').innerText = lang.firstInstallment;
    installments[1].innerHTML = lang.secondInstallment;
});